﻿window.cBuilderEmailWidgetRGPDTout = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetrgpdtout'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>RGPD:Tout</div>").appendTo($DivBt)
        $DivBt.attr("title", "<div style='text-align:left;'>RGPD:<b>Ajouter une ligne avec toutes les informations RGPD pour être conforme</b><br/>Ce widget intègre:<br/> &bull; Lien de désinscription,<br/> &bull; Lien de désactivation du pixel de tracking,<br/> &bull; Lien sur la politique de confidentialité,<br/> &bull; Nom de la société qui a envoyé le message,<br/> &bull; Affiche de la source de l'email du destinataire si premier envoi.</div>")
        return $DivBt
    }

    this.mCreateElement = function () {
        if (!option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par") || option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par").length == 0) {
            var dataSociete = option.bddCtrl.mGetArray("societe")[0]
            if (dataSociete) {
                option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par", dataSociete.nom)
            }
        }

        if (!option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite").length == 0) {
            var dataSociete = option.bddCtrl.mGetArray("societe")[0]
            if (dataSociete) {
                option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", dataSociete.nom)
            }
        }
        if (!option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite", option.bddCtrl.utiCourant.adresse_email)
        }


        option.element = $("<tr class='widget dxwidgetrgpdtout'>")
        $("<!-- DEBUT RGPDTOUT -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("liendesinscription")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'></td>").appendTo($Tr)

        if (!option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desinscription_rgpd") || option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desinscription_rgpd").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desinscription_rgpd", "Se désinscrire")
        }
        $("<a href='about:blank' target='_blank' class='RGPDpopsoftADesinscription' style='white-space:nowrap;'></a>").appendTo($Td).text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desinscription_rgpd"))
        $("<span> &bull; </span>").appendTo($Td)

        if (!option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desactive_pixel_suivi") || option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desactive_pixel_suivi").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desactive_pixel_suivi", "Désactiver pixel suivi")
        }
        $("<a href='about:blank' target='_blank' class='RGPDApopsoftDesactivepixeltracking' style='white-space:nowrap;'></a>").appendTo($Td).text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desactive_pixel_suivi"))
        $("<span> &bull; </span>").appendTo($Td)


        if (!option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite", "Politique de confidentialité")
        }
        var $AA = $("<a href='about:blank' target='_blank' class='RGPDpopsoftAPolitiqueconfidentialite' nom_societe='' email_rgpd='' style='white-space:nowrap;'></a>").appendTo($Td).text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite"))
        $AA.attr("nom_societe", option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite"))
        $AA.attr("email_rgpd", option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite"))
        $("<br/>").appendTo($Td)

        var $Span = $("<span class='RGPDpopsoftAnomsociete' nom_societe=''/>").appendTo($Td)
        $Span.html("Vous recevez ce message de <b>" + option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par") + "</b>")
        $Span.attr("nom_societe", option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par"))
        $("<br/>").appendTo($Td)

        var $Span = $("<span class='RGPDpopsoftAsourceemail'/>").appendTo($Td)
        $Span.text("votre adresse professionnelle a été obtenue via ...(affiché au 1er envoi, sinon vide)")


        $("<!-- FIN RGPDTOUT -->").appendTo(option.element)
    }

    this.nom = "RGPD:Tout"
    this.icone = "fas fa-fingerprint"
    function mGetLinkDesinscription() { return $(option.element.find("a.RGPDpopsoftADesinscription")[0]) }
    function mGetLinkDesactivePixel() { return $(option.element.find("a.RGPDApopsoftDesactivepixeltracking")[0]) }
    function mGetLinkPolitique() { return $(option.element.find("a.RGPDpopsoftAPolitiqueconfidentialite")[0]) }
    function mGetEleSourceNomSociete() { return $(option.element.find("span.RGPDpopsoftAnomsociete")[0]) }

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Lien de désinscription:</td>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        var dxEmojiDesinscrire = $("<div style='margin-top:20px;margin-left:20px;'/>").appendTo(contentElement).dxCtrlTxtEmoji({
            labelMode: "floating",
            label: "Texte du lien de désincription",
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: mGetLinkDesinscription().text(),
            onValueChanged: function (value) {
                if (value == null || value.length == 0) {
                    dxEmojiDesinscrire.mSetValue("Se désincrire")
                } else {
                    mGetLinkDesinscription().text(value)
                }
            }
        }).dxCtrlTxtEmoji("instance")


        $("<div style='width:1px;white-space:nowrap;font-size:120%;margin-top:20px;font-weight:bold;' class=''>Lien de désactivation pixel de suivi:</td>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        var dxEmojiPixelsuivi = $("<div style='margin-top:20px;margin-left:20px;'/>").appendTo(contentElement).dxCtrlTxtEmoji({
            labelMode: "floating",
            label: "Texte du lien de désactivation du pixel de suivi",
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: mGetLinkDesactivePixel().text(),
            onValueChanged: function (value) {
                if (value == null || value.length == 0) {
                    dxEmojiPixelsuivi.mSetValue("Désactiver pixel suivi")
                } else {
                    mGetLinkDesactivePixel().text(value)
                }
            }
        }).dxCtrlTxtEmoji("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;margin-top:20px;font-weight:bold;' class=''>Politique de confidentialité:</td>").appendTo(contentElement)
        $("<div style='font-family:barlow condensed;margin-top:10px;margin-left:20px;'>Ce composant génère un lien sur la politique de confidentialité par défaut de " + parametre.nom + ". Vous devez saisir le nom de votre société et l'adresse email du responsable RGPD pour pouvoir générer votre politique de confidentialité.<br/>Si vous avez votre propre politique de confidentialité, vous pouvez choisir de mettre un lien sur celle-ci plutôt que ce widget.</div>").appendTo(contentElement)
        var $DivLientPolitique = $("<div style='font-family:barlow condensed;margin-top:10px;margin-left:20px;'/>").appendTo(contentElement)
        var $A = $("<a href='javascript:void(0)'>Voir la politique de confidentialité par défaut</a>").appendTo($DivLientPolitique)
        $A.on("click", function (e) {
            //afficher la politique de confidentialité
        })

        contentElement.closest(".dx-item-content").css("overflow", "visible")
        var dxEmojiPolitique = $("<div style='margin-top:20px;margin-left:20px;'/>").appendTo(contentElement).dxCtrlTxtEmoji({
            labelMode: "floating",
            label: "Texte du lien d'affichage de la politique de confidentialité",
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: mGetLinkPolitique().text(),
            onValueChanged: function (value) {
                if (value == null || value.length == 0) {
                    dxEmojiPolitique.mSetValue("Politique confidentialité")
                } else {
                    mGetLinkPolitique().text(value)
                    option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite", value)
                    option.onValueChanged()
                }
            }
        }).dxCtrlTxtEmoji("instance")

        //$("<br/>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div style='margin-top:10px;margin-left:20px;'/>").appendTo(contentElement).dxTextBox({
            labelMode: "floating",
            label: "Nom société",
            bddCtrl: option.bddCtrl,
            value: mGetLinkPolitique().attr("nom_societe"),
            onValueChanged: function (e) {
                mGetLinkPolitique().attr("nom_societe", e.value)
                option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", e.value)
                option.onValueChanged()
            }
        }).dxTextBox("instance")

        //$("<br/>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div style='margin-top:10px;margin-left:20px;'/>").appendTo(contentElement).dxTextBox({
            labelMode: "floating",
            label: "Email du responsable RGPD",
            bddCtrl: option.bddCtrl,
            value: mGetLinkPolitique().attr("email_rgpd"),
            onValueChanged: function (e) {
                mGetLinkPolitique().attr("email_rgpd", e.value)
                option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite", e.value)
                option.onValueChanged()
            }
        }).dxTextBox("instance")



        $("<div style='width:1px;white-space:nowrap;font-size:120%;margin-top:20px;font-weight:bold;' class=''>Société qui envoi l'email:</td>").appendTo(contentElement)
        $("<div style='margin-top:10px;margin-left:20px;'/>").appendTo(contentElement).dxTextBox({
            labelMode: "floating",
            label: "Nom société",
            bddCtrl: option.bddCtrl,
            value: option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par"),
            onValueChanged: function (e) {
                mGetEleSourceNomSociete().attr("nom_societe", e.value)
                option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par", e.value)
                mGetEleSourceNomSociete().html("Vous recevez ce message de <b>" + e.value + "</b>")
                option.onValueChanged()
            }
        }).dxTextBox("instance")

    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("liendesinscription")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("liendesinscription")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("liendesinscription")) {
            var lstEle = [option.parent.mGetBodyWidget()]
            switch (prop) {
                case "color": case "font-weight": case "font-style": case "text-decoration": case "line-height": case "letter-spacing": case "font-family": case "font-size":
                    lstEle.push(mGetLinkDesinscription())
                    lstEle.push(mGetLinkDesactivePixel())
                    lstEle.push(mGetLinkPolitique())
                    break;
            }
            lstEle.forEach(function (ele) {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    ele.css(prop, jsonCssData[prop])
                } else {
                    ele.css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("liendesinscription", prop))
                }
            })

        }
    }

}